export default [
	'error',
	'warning',
	'affirm',
	'information',
	'upgrade',
	'info-light',
];
